import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { CalendarAlert } from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import { AlertPopUp } from '../alertPopUp/AlertPopUp'

export type ProviderCalendarAlertsProps = {
  alerts: CalendarAlert[]
  onClose: (alert: CalendarAlert) => void
}

const Container = styled.View<{ isSideNavigationBarEnabled?: boolean }>(({ theme, isSideNavigationBarEnabled }) => ({
  flexDirection: 'column',
  position: 'fixed',
  // left offset for alert container when side nav is enabled will be 48px + 102px
  left: isSideNavigationBarEnabled ? '150px' : '48px',
  bottom: theme.spacing['48px'],
  zIndex: 3,
  gap: theme.spacing['16px'],
}))

export const ProviderCalendarAlerts: FunctionComponent<ProviderCalendarAlertsProps> = ({ alerts, onClose }) => {
  const { isSideNavigationBarEnabled } = useFlags()

  return (
    <Container isSideNavigationBarEnabled={isSideNavigationBarEnabled}>
      {alerts.map((alert) => (
        <AlertPopUp
          ariaLabel={alert.ariaLabel}
          key={alert.type}
          headerText={alert.title}
          text={alert.body}
          onClose={() => onClose(alert)}
          secondaryButton={
            alert.actions?.primary && {
              onPress: alert.actions.primary.onClick,
              text: alert.actions.primary.label,
              testID: alert.actions.primary.testID,
              loading: alert.actions.primary.isLoading,
            }
          }
          tertiaryButton={
            alert.actions?.secondary && {
              onPress: alert.actions.secondary.onClick,
              text: alert.actions.secondary.label,
              testID: alert.actions.secondary.testID,
              loading: alert.actions.secondary.isLoading,
            }
          }
        />
      ))}
    </Container>
  )
}
